export default "__VITE_ASSET__9712228d__"